module.exports = __webpack_public_path__ + "img/IMG_3600.f2d2ab43.webp";